'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import AuthLeftPanel from './AuthLeftPanel';

export default function AuthPageClient() {
  const [mode, setMode] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen flex bg-mesh">
      {/* Left brand panel */}
      <AuthLeftPanel />

      {/* Right form panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 lg:px-16 xl:px-24 min-h-screen overflow-y-auto scrollbar-thin">
        <div className="w-full max-w-md animate-slide-up">
          {/* Back to home */}
          <div className="mb-6">
            <a href="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back to CompanyInbox
            </a>
          </div>

          {/* Mode toggle */}
          <div className="flex gap-1 p-1 glass-card rounded-xl mb-8 w-fit">
            <button
              onClick={() => setMode('login')}
              className={`px-5 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${
                mode === 'login' ?'bg-white text-foreground shadow-card' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setMode('signup')}
              className={`px-5 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${
                mode === 'signup' ?'bg-white text-foreground shadow-card' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Create Account
            </button>
          </div>

          {mode === 'login' ? (
            <LoginForm onSwitchToSignup={() => setMode('signup')} />
          ) : (
            <SignUpForm onSwitchToLogin={() => setMode('login')} />
          )}
        </div>
      </div>
    </div>
  );
}